import DispatchConstants from '../../constants/DispatchConstants';

import Properties from '../../model/Properties';

const initialProperties = Properties();

const initState = () => ({
  statsDaysBack: 0,
  restrictions: {},
  listingAliases: [],
  tourCountByListingAlias: {},
  leadCountByListingAlias: {},
  hasSubNavFiltersBeenTouched: false,
  ...initialProperties,
});

const properties = (state = initState(), action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case DispatchConstants.UPDATE_PROPERTIES: {
      const { listingsModel } = payload;
      const listingAliases = listingsModel.listings.map((listing) => listing.listingAlias);

      return Object.assign({}, state, listingsModel, { listingAliases });
    }

    case DispatchConstants.UPDATE_PROPERTIES_TOUR_COUNT: {
      const { tourCountForListings } = payload;
      const copyTourCountByListingAlias = { ...state.tourCountByListingAlias };

      tourCountForListings.forEach((tour) => {
        const hasListingAlias = copyTourCountByListingAlias.hasOwnProperty(tour.listingAlias);
        const totalTourCount =
          (tour.userPropertyToursCount.vrModelsCount ?? 0) + (tour.userPropertyToursCount.externalToursCount ?? 0);
        if (
          !hasListingAlias ||
          (hasListingAlias && copyTourCountByListingAlias[tour.listingAlias] !== totalTourCount)
        ) {
          copyTourCountByListingAlias[tour.listingAlias] = totalTourCount;
        }
      });

      return Object.assign({}, state, { tourCountByListingAlias: copyTourCountByListingAlias });
    }

    case DispatchConstants.UPDATE_PROPERTIES_LEAD_COUNT: {
      const { leadCountForListings } = payload;
      const copyLeadCountByListingAlias = { ...state.leadCountByListingAlias };

      leadCountForListings.forEach(({ listingAlias, totalProspectCount, totalProspectCountMessage }) => {
        const hasLeadCount = copyLeadCountByListingAlias.hasOwnProperty(listingAlias);

        if (!hasLeadCount || (hasLeadCount && copyLeadCountByListingAlias[listingAlias] !== totalProspectCount)) {
          copyLeadCountByListingAlias[listingAlias] = totalProspectCountMessage;
        }
      });

      return Object.assign({}, state, { leadCountByListingAlias: copyLeadCountByListingAlias });
    }

    case DispatchConstants.UPDATE_SUB_NAV_FILTERS_TOUCHED:
      return { ...state, hasSubNavFiltersBeenTouched: payload };

    default:
      return state;
  }
};

export default properties;
